import { AssignmentBudgetFilters, defaultAssignmentBudgetFilter } from "@app/constants/filters.defaults.tsx";
import { ActiveEnums } from "@app/data/engine.ts";
import useAssignmentData from "@app/data-hooks/use-assignment-data.ts";
import { Box, Grid2, Stack, Tooltip } from "@mui/material";
import { QueryStatusRouter, Select } from "bi-lib";
import { useState } from "react";
import AllYesNoCheckbox from "./all-yes-no-checkbox.tsx";
import FiltersContainer from "./filters-container.tsx";

interface Props {
    assignmentId: number;
    filters: AssignmentBudgetFilters;
    setFilters: (filters: AssignmentBudgetFilters) => void;
    rateType: "billing" | "cost" | "internal";
    setRateType: (value: "billing" | "cost" | "internal") => void;
}

export default function BudgetFilters({ assignmentId, filters, setFilters, rateType, setRateType }: Props) {
    const [staffActiveState, setStaffActiveState] = useState<ActiveEnums>(ActiveEnums.ActiveOnly);

    const { rosterList } = useAssignmentData({ id: assignmentId, activeState: staffActiveState });

    return (
        <FiltersContainer onReset={() => setFilters(defaultAssignmentBudgetFilter)}>
            <Grid2 container spacing={2} width={"100%"}>
                <Grid2 size={6}>
                    <Stack spacing={1}>
                        <Select
                            label={"Rate Type"}
                            value={rateType}
                            onChange={(e) => setRateType(e as "billing" | "cost" | "internal")}
                            options={[
                                { label: "Billing", value: "billing" },
                                { label: "Cost", value: "cost" },
                                { label: "Internal", value: "internal" },
                            ]}
                        />
                    </Stack>
                </Grid2>
                <Grid2 size={6}>
                    <Stack spacing={1}>
                        <QueryStatusRouter queryHook={rosterList}>
                            <Select
                                label={"Staff"}
                                value={filters.staffId}
                                onChange={(e) =>
                                    setFilters({
                                        ...filters,
                                        staffId: e,
                                    })
                                }
                                options={rosterList.data?.map((x) => ({
                                    label: `${x.lastName}, ${x.firstName}`,
                                    value: x.staffId,
                                }))}
                                endAdornment={
                                    <Box display={"flex"} pr={1} flexDirection={"column"}>
                                        <Tooltip title={"Active Only"}>
                                            <AllYesNoCheckbox
                                                value={staffActiveState}
                                                onChange={(e) => setStaffActiveState(e)}
                                                inactiveText={"Inactive"}
                                                activeText={"Active"}
                                            />
                                        </Tooltip>
                                    </Box>
                                }
                            />
                        </QueryStatusRouter>
                    </Stack>
                </Grid2>
            </Grid2>
        </FiltersContainer>
    );
}
